import { toast } from 'react-toastify'

// The add/edit forms redirect to a list page with ?saved=<key> so the
// confirmation survives the navigation (the list pages own the ToastContainer,
// the forms do not). The keys are generic ('created'/'updated'/'deleted')
// because one form serves several lists — each list names the record itself by
// passing its own messages to showSavedMessage.
const defaultMessages = {
  'profile-updated': 'Profile updated successfully!'
}

/**
 * Set the ?saved=<key> flag on a redirect url, preserving the rest of its
 * query. Overwrites any existing flag: a backUrl captured from a page that
 * still carried an older flag would otherwise win, since URLSearchParams.get
 * returns the first of the duplicated values.
 */
export function withSavedFlag(url, key) {
  const queryStart = url.indexOf('?')
  const path = queryStart === -1 ? url : url.slice(0, queryStart)
  const params = new URLSearchParams(
    queryStart === -1 ? '' : url.slice(queryStart + 1)
  )
  params.set('saved', key)
  return `${path}?${params.toString()}`
}

/**
 * Show the message for the ?saved= flag on the current url, then drop it.
 * `messages` maps the flag ('created' | 'updated' | 'deleted') to the wording
 * for the records this page lists.
 */
export function showSavedMessage(messages, search) {
  const saved = new URLSearchParams(
    search === undefined ? window.location.search : search
  ).get('saved')
  const message = (messages && messages[saved]) || defaultMessages[saved]
  if (!message) {
    return
  }
  toast.success(message, { position: 'top-right', autoClose: 3000 })
  // Drop the flag so the message is not repeated on refresh or paging.
  const url = new URL(window.location.href)
  url.searchParams.delete('saved')
  window.history.replaceState({}, '', `${url.pathname}${url.search}`)
}
